import { z } from 'zod';

import { pii } from './pii';

export const ExportableOptionalPhoneNumber = pii(
  z.string().optional().meta({
    description: 'Phone number',
    nullable: true,
  }),
);

/* -------- */
export const ExportablePhone = z.object({
  home: ExportableOptionalPhoneNumber,
  work: ExportableOptionalPhoneNumber,
  cell: ExportableOptionalPhoneNumber,
  other: ExportableOptionalPhoneNumber,
});
export type ExportablePhone = z.infer<typeof ExportablePhone>;
